skrilla.controller('updateUserStatusModalCtrl', function ($scope, cacheService,  modalService,
                                                          searchService, validationService, dateService) {
    $scope.pageKey = "updateUserStatus";
    $scope.user = cacheService.getObject($scope.pageKey);

    const newStatus = $scope.user.status === "ACTIVE" ? "CLOSED" : "ACTIVE";
    $scope.lockButton = false;
    $scope.minDate = dateService.getTomorrowDate()
    $scope.validate = {}

    $scope.update = {
        status: newStatus,
        alertUser: false,
        indefinite: false
    }

    function toggleLockButton() {
        $scope.lockButton = !$scope.lockButton
    }

    searchService.get("users/excludedPersonClosedReasons").then(function (response) {
        $scope.exclduedPersonClosedReasons = response.data
    })

    searchService.get("users/otherClosedReasons").then(function (response) {
        $scope.otherClosedReasons = response.data
    })

    $scope.isExcludedPersonClosedReason = function() {
        return $scope.exclduedPersonClosedReasons.includes($scope.update.closedReason)
    }

    $scope.save = function() {
        toggleLockButton()
        setClosedUntil()
        if (validate()) {
            modalService.confirm("Are you sure you'd like to update this user's status?", function () {
                searchService.put("users/" + $scope.user.id + "/status", $scope.update,
                        "User Successfully updated! Note and Ticket Created!").then(function () {
                    modalService.dismissAll();
                    $scope.user.status = newStatus;
                    $scope.user.closedReason = $scope.update.closedReason;
                    $scope.user.closedUntil = $scope.update.closedUntil;
                    cacheService.getObject("updateEntityNotesFn")();
                })
            }, function () {
                toggleLockButton();
                $scope.apply();
            })
        } else {
            toggleLockButton()
        }
    }

    function setClosedUntil() {
        if (!$scope.isExcludedPersonClosedReason()) {
            $scope.update.closedUntil = null;
        } else if ($scope.update.indefinite === true) {
            $scope.update.closedUntil = new Date();
            $scope.update.closedUntil.setFullYear(3000);
        }
    }

    function validate() {
        let inputs = [
            validationService.buildFieldValidationObj("description",
                validationService.isNotEmpty($scope.update.description), "Please provide a description")
        ]
        if (newStatus === "CLOSED") {
            inputs.push(validationService.buildFieldValidationObj("closedReason",
                validationService.isNotEmpty($scope.update.closedReason), "Please select a reason"))
            if ($scope.isExcludedPersonClosedReason()) {
                inputs.push(validationService.buildFieldValidationObj("closedUntil",
                    validationService.isNotEmpty($scope.update.closedUntil),
                    "Please enter a closed until date, or select 'Indefinite'"))
            }
        }
        return validationService.validateForm(inputs, $scope.validate)
    }

    $scope.close = function () {
        modalService.dismissAll()
    }

});

